import { Button, Card, Col, Form, Row } from "react-bootstrap";
import PageTemplate from "../../templates/Pagetemplate";
import BreadCrumb from "../../molecules/BreadCrumb";
import { useForm } from "react-hook-form";
import InputGroupValidation from "../../molecules/InputGroupValidation";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import MobileAuth from "../../molecules/MobileAuth";
import { useMutation } from "@tanstack/react-query";
import { showAlert } from "../../../../reducer/alertSlice";
import axios from "axios";
import { useCheckDirtyField } from "../../../common/hook";

export default function AddAdmin(props) {
    const [dirty, setDirty] = useState(false);
    const [phone, setPhone] = useState();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {register, handleSubmit, watch, setValue, getValues, formState} = useForm();
    const {checkFieldConfirm} = useCheckDirtyField();


    // 등록 버튼 클릭
    const onSubmit = handleSubmit((data) => {
        if (phone) {
            addAdmin.mutate();
        } else {
            dispatch(showAlert({
                msg: <>필수 항목이 입력되지 않았습니다.<br/>다시 확인해주세요.</>
            }))
        }
    })
    
    // 등록
    const addAdmin = useMutation({
        mutationKey: ['addAdmin'],
        mutationFn: () => {
            return axios("/admin/add", {
                method: "POST",
                data: getValues()
            }).then(result => {
                if (result.status == "201") {
                    dispatch(showAlert({
                        msg: "등록되었습니다.",
                        func: () => {
                            navigate("/admin/list/chief")
                        }
                    }))
                } else {
                    dispatch(showAlert({
                        msg: <>오류가 발생했습니다.<br/>잠시 후 다시 시도해주세요.</>,
                    }))
                }
            })
        }
    })

    useEffect(() => {
        setValue("phone", phone);
    },[phone]);

    useEffect(() => {
        const subscription = watch((formValue) => {
            setDirty(true);
        });
        return () => subscription.unsubscribe();
    },[watch]);
    return (
        <>
        
            <PageTemplate.Top>
                <BreadCrumb arr={[<Link to="/admin/list/company">관리자 설정</Link>, <Link to="/admin/list/chief/">최고 관리자</Link>, <span className="fw-bold">최고 관리자 등록</span>]} />
                <h1 className="page-title">최고 관리자 등록</h1>
            </PageTemplate.Top>

            <PageTemplate.Content>

                <Card className="mt-4 overflow-hidden">
                    <Card.Header>
                        <Card.Title className="fs-3">관리자 정보</Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <Form.Group as={Row} className="mb-3" controlId="formPhone">
                            <Form.Label column sm="2">
                                휴대폰 번호 *
                            </Form.Label>
                            <Col sm="8">
                                <MobileAuth 
                                    type="2"
                                    addValue={(value) => {
                                        setPhone(value);
                                    }} 
                                    removeValue={() => {
                                        setPhone("");
                                    }}
                                    />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="formPosition">
                            <Form.Label column sm="2">
                                직책 *
                            </Form.Label>
                            <Col sm="8">
                                <InputGroupValidation placeholder="직책을 입력하세요" 
                                    max={13}
                                    register={register("position", {
                                        required: "직책을 입력하세요"
                                    })}
                                    invalid={formState.errors['position']}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="formName">
                            <Form.Label column sm="2">
                                이름 *
                            </Form.Label>
                            <Col sm="8">
                                <InputGroupValidation placeholder="이름을 입력하세요" 
                                    max={13}
                                    register={register("name", {
                                        required: "이름을 입력하세요"
                                    })}
                                    invalid={formState.errors['name']}
                                />
                            </Col>
                        </Form.Group>
                    </Card.Body>
                </Card>
            </PageTemplate.Content>

            <PageTemplate.ButtonContainer>
                <Button variant="outline-secondary" onClick={() => {
                    checkFieldConfirm(dirty);
                }}>취소</Button>
                <Button variant="primary" type="button" onClick={onSubmit}>등록</Button>
            </PageTemplate.ButtonContainer>
        </>
    );
}
